import { TRoadblocksListItem2, TRoadblockStatus } from "../../../domain/codecs/form/RoadblockForm";
import { ListingRoadblockType_displayString, TListingRoadblocksListItem } from "../../../domain/codecs/form/ListingRoadblockForm";
import { TPlainUser } from "../../../domain/codecs/User";
import { capitaliseFirst, underscoreCaseToNormalCase } from "../../../shared/src/utilsByDomain/string";

export type TRoadblockListView = {
    id: string;
    display_name: string;
    status: TRoadblockStatus;
    opened_on: string | null;
    sla: string;
    last_closed_on: string | null;
    blocked_till: string | null;
    blocked_waiting_on: string | null;
    blocked_waiting_on_is_internal: boolean;
    assigned_user: TPlainUser | undefined;
};

export const roadblockListViewFromCaseItem = (item: TRoadblocksListItem2): TRoadblockListView => ({
    id: item.id,
    display_name: capitaliseFirst(underscoreCaseToNormalCase(item.type)),
    status: item.status,
    opened_on: item.opened_on,
    sla: item.sla,
    last_closed_on: item.last_closed_on,
    blocked_till: item.blocked_till,
    blocked_waiting_on: item.blocked_waiting_on,
    blocked_waiting_on_is_internal: item.blocked_waiting_on_is_internal,
    assigned_user: item.assigned_users[0],
});

export const roadblockListViewFromListingItem = (item: TListingRoadblocksListItem): TRoadblockListView => ({
    id: item.id,
    display_name: ListingRoadblockType_displayString(item.listing_roadblock_type),
    status: item.status,
    opened_on: item.opened_on,
    sla: item.sla,
    last_closed_on: item.last_closed_on,
    blocked_till: item.blocked_till,
    blocked_waiting_on: item.blocked_waiting_on,
    blocked_waiting_on_is_internal: item.blocked_waiting_on_is_internal,
    assigned_user: item.assigned_to_user ?? undefined,
});
